// _controllers/page_transition_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["page"]

  connect() {
    // IMPORTANTÍSIMO:
    // limpiar estados viejos al conectar
    this.pageTarget.classList.remove("leaving")

    // siguiente frame => estado estable
    requestAnimationFrame(() => {
      this.pageTarget.classList.add("ready")
    })

    this.boundClick = this.click.bind(this)
    this.boundPageShow = this.pageshow.bind(this)

    document.addEventListener("click", this.boundClick)
    window.addEventListener("pageshow", this.boundPageShow)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClick)
    window.removeEventListener("pageshow", this.boundPageShow)
  }

  pageshow() {
    // safari/firefox bfcache fix
    this.pageTarget.classList.remove("leaving")
  }

  click(e) {
    const link = e.target.closest("a[href]")

    if (!link) return

    const href = link.getAttribute("href")

    // ignorar:
    if (
      !href ||
      href.startsWith("#") ||
      href.startsWith("http") ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:") ||
      link.target === "_blank" ||
      link.hasAttribute("download") ||
      link.dataset.action ||
      link.dataset.turbo === "false" ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }

    e.preventDefault()

    this.pageTarget.classList.add("leaving")

    setTimeout(() => {
      window.location.href = href
    }, 300)
  }
}